import { useEffect } from "react";
import type { StartupRoute } from "@household/shared/startup-telemetry";
import { finishStartup, startupContext, startupError, startupRouteReady, startupStage } from "../lib/startupTelemetry.js";
import { hasUsableShellTranslations } from "./i18n.js";
import type { ResolvedLocale } from "./locale.js";

export function useStartupStages(route: StartupRoute, locale: ResolvedLocale, authReady: boolean,
  translationStatus: string, translationError: string | null, unreachable: boolean, authScreen: boolean) {
  useEffect(() => {
    startupContext(route, locale);
    if (authReady) startupStage("i18nStartMs");
    if (translationStatus === "error") {
      startupError(translationError === "translations_timeout" ? "i18n_timeout" : "i18n_failed");
      finishStartup("error");
    }
    if (!authReady || translationStatus !== "ready" || unreachable) return;
    if (!hasUsableShellTranslations(locale)) {
      startupError("shell_without_translations");
      finishStartup("error");
      return;
    }
    startupStage("i18nReadyMs");
    startupStage("shellVisibleMs");
    if (authScreen) startupRouteReady();
  }, [route, locale, authReady, translationStatus, translationError, unreachable, authScreen]);
}
